/* ABSCENTS — Marcas EN VIVO.
   Pide en segundo plano la lista viva de casas (sección abx-marcas-datos: proveedores de la tienda, conteo de
   cada colección y catálogo Nicho/Diseñador/Árabe) y actualiza el menú móvil, el mega menú de escritorio y el
   directorio. La guarda 30 min en la sesión. Si algo falla, se queda la lista que trae el tema. */
(function () {
  if (window.abxMarcas) return;
  var KEY = 'abxMarcasV1', TTL = 30 * 60 * 1000, MIN = 50;
  var RAMAS = { disenador: 'D', nicho: 'N', arabes: 'A', todas: '' };

  function leer() {
    try {
      var o = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (o && o.d && Date.now() - o.t < TTL) return o.d;
    } catch (e) {}
    return null;
  }
  function guardar(d) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }
  function parse(d) {
    var out = [];
    String(d || '').split(';').forEach(function (r) {
      var f = r.split('|');
      if (f.length < 5 || !f[2]) return;
      out.push({ n: f[0], c: parseInt(f[1], 10) || 0, h: f[2], l: f[3], k: f[4] });
    });
    return out.length >= MIN ? out : null;
  }
  function url() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var u = root + '?section_id=abx-marcas-datos';
    try {
      if (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') u += '&preview_theme_id=' + Shopify.theme.id;
    } catch (e) {}
    return u;
  }
  var pend = null;
  function get() {
    var c = parse(leer());
    if (c) return Promise.resolve(c);
    if (pend) return pend;
    pend = fetch(url(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.getElementById('abx-marcas-datos');
        var d = s ? JSON.parse(s.textContent) : '';
        var lista = parse(d);
        if (!lista) throw new Error('lista vacía');
        guardar(d);
        return lista;
      });
    pend.catch(function () { pend = null; });
    return pend;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase(); }
  function miles(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function deRama(lista, cat) { return lista.filter(function (m) { return !cat || m.k === cat; }); }

  /* Menú móvil: mismo HTML que snippets/abscents-marcas-menu.liquid */
  function htmlRama(slug, ms) {
    var letras = [], vistas = {};
    ms.forEach(function (m) { if (!vistas[m.l]) { vistas[m.l] = 1; letras.push(m.l); } });
    letras.sort(function (a, b) { return a === '#' ? 1 : b === '#' ? -1 : a < b ? -1 : a > b ? 1 : 0; });
    var h = '<li class="slide-nav__item abx-menu-search-item"><span class="abx-menu-searchwrap"><input type="search" class="abx-menu-search" data-rama="' + slug + '" placeholder="Buscar entre ' + ms.length + ' marcas…" aria-label="Buscar marca"><button type="button" class="abx-menu-clear" aria-label="Limpiar">&times;</button></span></li>';
    h += '<li class="slide-nav__item abx-menu-alpha" role="navigation" aria-label="Índice">';
    letras.forEach(function (L) { h += '<button type="button" class="abx-menu-letter" data-letter="' + L + '">' + L + '</button>'; });
    h += '</li>';
    var prev = '';
    ms.forEach(function (m) {
      if (m.l !== prev) {
        h += '<li class="slide-nav__item abx-menu-divider" data-letter="' + m.l + '"><span>' + m.l + '</span></li>';
        prev = m.l;
      }
      h += '<li class="slide-nav__item abx-menu-brand" data-n="' + esc(norm(m.n)) + '" data-letter="' + m.l + '"><a href="/collections/' + esc(m.h) + '" class="slide-nav__link abx-menu-brand__link"><span class="abx-menu-name">' + esc(m.n) + '</span><span class="abx-menu-count">' + m.c + '</span></a></li>';
    });
    h += '<li class="slide-nav__item abx-menu-empty" hidden><span class="slide-nav__link"><span>Sin coincidencias en esta rama</span><a class="abx-menu-rescue" href="/collections/todos-los-perfumes">Ver todos los perfumes &rarr;</a></span></li>';
    return h;
  }
  function aplicarMovil(lista) {
    document.querySelectorAll('[data-rama-panel]').forEach(function (panel) {
      var slug = panel.getAttribute('data-rama-panel');
      if (!(slug in RAMAS)) return;
      var html = htmlRama(slug, deRama(lista, RAMAS[slug]));
      var tpl = panel.querySelector('template.abx-menu-tpl');
      if (tpl) { tpl.innerHTML = html; return; }
      /* El panel ya se abrió: se reconstruye sin perder lo que estaban buscando */
      var inp = panel.querySelector('.abx-menu-search');
      if (inp && document.activeElement === inp) return;
      var q = inp ? inp.value : '';
      panel.querySelectorAll('.abx-menu-search-item,.abx-menu-alpha,.abx-menu-divider,.abx-menu-brand,.abx-menu-empty')
        .forEach(function (n) { n.remove(); });
      panel.insertAdjacentHTML('beforeend', html);
      var ni = panel.querySelector('.abx-menu-search');
      if (ni) { ni.value = q; ni.dispatchEvent(new Event('input', { bubbles: true })); }
    });
  }

  /* Mega menú de escritorio: totales de la rama y las 15 casas con más perfumes */
  function aplicarEscritorio(lista) {
    document.querySelectorAll('[data-abx-rama]').forEach(function (li) {
      var cat = RAMAS[li.getAttribute('data-abx-rama')];
      if (!cat) return;
      var ms = deRama(lista, cat);
      var p = ms.reduce(function (a, m) { return a + m.c; }, 0);
      var meta = li.querySelector('.abx-mega__meta');
      if (meta) meta.textContent = ms.length + ' casas · ' + miles(p) + ' perfumes';
      var cta = li.querySelector('.abx-mega__cta');
      if (cta && cta.firstChild && cta.firstChild.nodeType === 3) cta.firstChild.nodeValue = 'Ver las ' + ms.length + ' casas ';
      var grid = li.querySelector('.abx-mega__grid');
      if (grid) {
        var top = ms.slice().sort(function (a, b) { return b.c - a.c || (a.n < b.n ? -1 : a.n > b.n ? 1 : 0); }).slice(0, 15);
        grid.innerHTML = top.map(function (m) {
          return '<li><a href="/collections/' + esc(m.h) + '"><span>' + esc(m.n) + '</span><span class="abx-mega__n">' + m.c + '</span></a></li>';
        }).join('');
      }
    });
  }

  /* Directorio A–Z (sections/marcas-directorio.liquid expone window.abxDirectorio) */
  function aplicarDirectorio(lista) {
    if (typeof window.abxDirectorio === 'function') {
      window.abxDirectorio(lista.map(function (m) { return [m.n, m.c, m.k, m.h]; }));
    }
  }

  var aplicada = false;
  function aplicar(lista) {
    aplicada = true;
    try { aplicarMovil(lista); } catch (e) {}
    try { aplicarEscritorio(lista); } catch (e) {}
    try { aplicarDirectorio(lista); } catch (e) {}
  }
  function arrancar() { get().then(aplicar).catch(function () {}); }

  window.abxMarcas = { get: get, cache: function () { return parse(leer()); } };

  function programar() {
    var c = parse(leer());
    if (c) { aplicar(c); return; }
    if ('requestIdleCallback' in window) requestIdleCallback(arrancar, { timeout: 3000 });
    else setTimeout(arrancar, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();

  /* Si abren el menú antes de que llegue la lista, se pide en ese momento */
  document.addEventListener('click', function (e) {
    if (!aplicada && e.target.closest && e.target.closest('[data-rama-btn], [data-abx-rama]')) arrancar();
  }, true);
})();
